import React from "react";
import ReactDOM from 'react-dom';
import $ from 'jquery';

class Timeline extends React.Component{
    constructor(props) {
        super(props)
        //console.log(this.props)
        this.handleRowClick = this.handleRowClick.bind(this);
    }
    
    handleRowClick(event){
        if(event.target.getAttribute('href').length>0){
            window.open(event.target.getAttribute('href'))
        }
    }
    
    render(){
    var rowNum = this.props.obj.json.length
    //var colNum = this.props.obj.headers.length
    var items = []
    //var header = []
    for(var i=0; i<rowNum; i++){
        var by_str = !!this.props.obj.json[i]["Sales Rep Name"] ? ' by ' + this.props.obj.json[i]["Sales Rep Name"] : ""
        items.push(<a class="border-bottom-0 notification rounded-0 border-x-0 border border-300" href={this.props.obj.json[i]["Item Link"]}>
                <div class="notification-avatar">
                  <div class="avatar avatar-xl me-3">
                    <div class="avatar-emoji rounded-circle "><span role="img" aria-label="Emoji">{this.props.obj.json[i]["Emoji"]}</span></div>
                  </div>
                </div>
                <div class="notification-body">
                  <p class="mb-1"><strong>{this.props.obj.json[i]["Action"]} {this.props.obj.json[i]["Lead Name"]}</strong>{by_str}</p>
                  <span class="notification-time">On {this.props.obj.json[i]["At"]}</span>
                </div>
              </a>)
    }

    return  <div>{items}</div>
    }
}

export default Timeline